import { deepFreeze } from '../../util/deepFreeze';
/** English translations */
export var englishTranslations = {
    Apr: 'Apr',
    Aug: 'Aug',
    contributions: {
        0: 'No contributions on',
        1: 'contribution on',
        other: 'contributions on'
    },
    Dec: 'Dec',
    Feb: 'Feb',
    Friday: 'Fri',
    hideZero: true,
    Jan: 'Jan',
    Jul: 'Jul',
    Jun: 'Jun',
    Mar: 'Mar',
    May: 'May',
    Monday: 'Mon',
    Nov: 'Nov',
    Oct: 'Oct',
    order: 0 /* COUNT_TEXT_DATE */,
    Sep: 'Sep',
    Wednesday: 'Wed'
};
deepFreeze(englishTranslations);



//////////////////
// WEBPACK FOOTER
// ./src/GhContribCalendar/Translate/defaultTranslations/en.ts
// module id = 25
// module chunks = 0 1